// extracted by mini-css-extract-plugin
export default {"profile-columns":"ProfileColumns_profile-columns__lRWR2"};